<template>
  <!--  <div>-->
  <!--    <div v-if="stateInit">-->
  <!--      &lt;!&ndash; Header &ndash;&gt;-->
  <!--      <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">-->
  <!--        <div class="container">-->
  <!--          <div class="header-body text-center mb-7">-->
  <!--            <div class="row justify-content-center">-->
  <!--              <div class="col-xl-5 col-lg-6 col-md-8 px-5">-->
  <!--                <h1 class="text-white">Account</h1>-->
  <!--                <p class="text-lead text-white">Login</p>-->
  <!--              </div>-->
  <!--            </div>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--        <div class="separator separator-bottom separator-skew zindex-100">-->
  <!--          <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"-->
  <!--               xmlns="http://www.w3.org/2000/svg">-->
  <!--            <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>-->
  <!--          </svg>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--      &lt;!&ndash; Page content &ndash;&gt;-->
  <!--      <div class="container mt&#45;&#45;8 pb-5">-->
  <!--        &lt;!&ndash; Table &ndash;&gt;-->
  <!--        <div class="row justify-content-center">-->
  <!--          <div class="col-lg-6 col-md-8">-->
  <!--            <div class="card bg-secondary border-0">-->
  <!--              <div class="card-body px-lg-5 py-lg-5">-->
  <!--                <div class="text-center text-muted mb-4">-->
  <!--                  <small>sign up with credentials</small>-->
  <!--                </div>-->
  <!--                <validation-observer v-slot="{handleSubmit}" ref="formValidator">-->
  <!--                  <form role="form" @submit.prevent="handleSubmit(onSubmit('initiateAuth'))">-->
  <!--                    <base-input alternative-->
  <!--                                class="mb-3"-->
  <!--                                prepend-icon="ni ni-hat-3"-->
  <!--                                placeholder="Username"-->
  <!--                                name="Username"-->
  <!--                                :rules="{email: false}"-->
  <!--                                v-model="model.name">-->
  <!--                    </base-input>-->
  <!--                    <base-input alternative-->
  <!--                                class="mb-3"-->
  <!--                                prepend-icon="ni ni-lock-circle-open"-->
  <!--                                placeholder="password"-->
  <!--                                type="password"-->
  <!--                                name="Password"-->
  <!--                                :rules="{required: true, min: 8}"-->
  <!--                                v-model="model.password">-->
  <!--                    </base-input>-->
  <!--                    <div class="text-center">-->
  <!--                      <button type="submit" :disabled="handleSubmit" class="btn btn-primary mt-4">-->
  <!--                        Login-->
  <!--                      </button>-->
  <!--                    </div>-->
  <!--                  </form>-->
  <!--                </validation-observer>-->
  <!--              </div>-->
  <!--            </div>-->
  <!--            <div class="row mt-3">-->
  <!--              <div class="col-6">-->
  <!--                <small @click="stateForgotPassword=true,stateInit=false">Forgot password?</small>-->
  <!--              </div>-->
  <!--              <div class="col-6 text-right">-->
  <!--                <router-link to="/register" class="text-light"><small>Create new account</small>-->
  <!--                </router-link>-->
  <!--              </div>-->
  <!--            </div>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--    <div v-if="stateForgotPassword">-->
  <!--      <forgot-password/>-->
  <!--    </div>-->
  <!--    <div v-if="stateSetNewPassword">-->
  <!--      <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">-->
  <!--        <div class="container">-->
  <!--          <div class="header-body text-center mb-7">-->
  <!--            <div class="row justify-content-center">-->
  <!--              <div class="col-xl-5 col-lg-6 col-md-8 px-5">-->
  <!--                <h1 class="text-white">Set New Password</h1>-->
  <!--                <p class="text-lead text-white">We have sent a password reset code by email to-->
  <!--                  {{this.sentTo}}. Enter it below to reset your password</p>-->
  <!--              </div>-->
  <!--            </div>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--        <div class="separator separator-bottom separator-skew zindex-100">-->
  <!--          <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"-->
  <!--               xmlns="http://www.w3.org/2000/svg">-->
  <!--            <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>-->
  <!--          </svg>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--      &lt;!&ndash; Page content &ndash;&gt;-->
  <!--      <div class="container mt&#45;&#45;8 pb-5">-->
  <!--        &lt;!&ndash; Table &ndash;&gt;-->
  <!--        <div class="row justify-content-center">-->
  <!--          <div class="col-lg-6 col-md-8">-->
  <!--            <div class="card bg-secondary border-0">-->
  <!--              <div class="card-body px-lg-5 py-lg-5">-->
  <!--                <div class="text-center text-muted mb-4">-->
  <!--                  <small>sign up with credentials</small>-->
  <!--                </div>-->
  <!--                <validation-observer v-slot="{handleSubmit}" ref="formValidator">-->
  <!--                  <form role="form"-->
  <!--                        @submit.prevent="handleSubmit(onSubmit('ConfirmForgotPassword'))">-->
  <!--                    <base-input alternative-->
  <!--                                class="mb-3"-->
  <!--                                prepend-icon="ni ni-hat-3"-->
  <!--                                placeholder="code"-->
  <!--                                name="code"-->
  <!--                                :rules="{required: true}"-->
  <!--                                v-model="model.code">-->
  <!--                    </base-input>-->

  <!--                    <base-input alternative-->
  <!--                                class="mb-3"-->
  <!--                                prepend-icon="ni ni-email-83"-->
  <!--                                placeholder="New Password"-->
  <!--                                name="password"-->
  <!--                                :rules="{required: true, min: 8}"-->
  <!--                                v-model="model.password">-->
  <!--                    </base-input>-->

  <!--                    <base-input alternative-->
  <!--                                class="mb-3"-->
  <!--                                prepend-icon="ni ni-lock-circle-open"-->
  <!--                                placeholder="Enter New Password Again"-->
  <!--                                type="password"-->
  <!--                                name="Confirm password"-->
  <!--                                :rules="{required:true, confirmed: 'password'}"-->
  <!--                                v-model="passwordagain"-->
  <!--                    >-->
  <!--                    </base-input>-->

  <!--                    <button type="submit" :disabled="handleSubmit" class="btn btn-primary mt-4">-->
  <!--                      Change-->
  <!--                      Password-->
  <!--                    </button>-->
  <!--                  </form>-->
  <!--                </validation-observer>-->
  <!--              </div>-->
  <!--            </div>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->
</template>
<script>

    // import ForgotPassword from "../../components/commons/ForgotPassword";

    export default {
        name: 'YsyLogin',
        // components: {ForgotPassword},
        // data() {
        //     return {
        //         stateInit: true,
        //         stateForgotPassword: false,
        //         stateSetNewPassword: false,
        //         passwordagain: '',
        //         passwordmatch: false,
        //         sentTo: '',
        //         model: {
        //             name: '',
        //             email: '',
        //             password: '',
        //             code: ''
        //         }
        //     }
        // },
        // methods: {
        //     async onSubmit(action) {
        //         console.log('register', this.model);
        //         const path = this.$base_url + "/register";
        //         var payload = {
        //             username: this.model['name'],
        //             email: this.model['email'],
        //             password: this.model['password'],
        //             code: this.model['code'],
        //             action: action
        //         };
        //
        //         await this.$http
        //             .post(path, payload).then(res => {
        //                     console.log(res);
        //                     if ('message' in res.data && res.data.message === 'The incoming token has expired') {
        //                         // window.location = "https://upgrademe.auth.eu-west-1.amazoncognito.com/login?response_type=code&client_id=" + this.API_KEY_CLIENT_VUE + "&redirect_uri=" + this.$base_url + "/authentication"
        //                         this.$router.push({name: 'login'});
        //                         return
        //                     }
        //                     if (action === 'ForgotPassword') {
        //                         this.sentTo = res.data.sentTo;
        //                         this.stateForgotPassword = false;
        //                         this.stateSetNewPassword = true;
        //                         console.log('sentTo', this.sentTo)
        //                     }
        //                     if (action === 'ConfirmForgotPassword') {
        //
        //                     }
        //                     if (action === 'Signup') {
        //                         this.confirmationState = true
        //                     }
        //                     if (action === 'initiateAuth' && res.data.success === true) {
        //                         let IdToken = res.data.message.AuthenticationResult.IdToken;
        //                         console.log('Success auth');
        //                         localStorage.id_token = IdToken;
        //                         this.parse_jwt_token(IdToken)
        //                     }
        //                 }
        //             ).catch(error => {
        //                 // eslint-disable-next-line
        //                 console.error(error);
        //                 this.notifyVue('danger')
        //             });
        //     },
        //     parse_jwt_token(token) {
        //         const dict_token = JSON.parse(atob(token.split('.')[1]));
        //         // console.log(dict_token);
        //
        //         if ("error" in dict_token) {
        //             this.$router.push({name: 'Landing'})
        //             return
        //         }
        //         // generate license
        //         if (!('custom:isBlocked' in dict_token)) {
        //             console.log("generate the license key")
        //             this.$http
        //                 .post(this.$base_url + "/generate_license", {
        //                     username: dict_token['cognito:username'],
        //                     id_token: localStorage.id_token
        //                 })
        //                 .then(res => {
        //                         if ('message' in res.data && res.data.message === 'The incoming token has expired') {
        //                             // window.location = "https://upgrademe.auth.eu-west-1.amazoncognito.com/login?response_type=code&client_id=" + this.API_KEY_CLIENT_VUE + "&redirect_uri=" + this.$base_url + "/authentication"
        //
        //                             this.$router.push({name: 'login'});
        //                             return
        //                         }
        //                         console.log(res)
        //                     }
        //                 ).catch(error => {
        //                     console.log(error)
        //                 }
        //             );
        //             const payload = {
        //                 "user": dict_token['cognito:username'],
        //                 "emailLinkedin": 'custom:email_linkedin' in dict_token ? dict_token['custom:email_linkedin'] : 'NaN',
        //                 "role": 'custom:role' in dict_token ? dict_token['custom:role'] : 'user',
        //                 "haveAccount": 'custom:haveAccount' in dict_token ? (dict_token['custom:haveAccount'] === 'true') : false,
        //                 "isBlocked": 'custom:isBlocked' in dict_token ? (dict_token['custom:isBlocked'] === 'true') : true,
        //                 "referrer": 'custom:referrer' in dict_token ? dict_token['custom:referrer'] : 'YSY',
        //             };
        //             this.$store.commit('auth_success', payload);
        //             this.$router.push({name: 'Profile'});
        //             return
        //         }
        //         // console.log(("role" in dict_token));
        //         // console.log(dict_token['custom:email_linkedin']);
        //         const payload = {
        //             "user": dict_token['cognito:username'],
        //             "emailLinkedin": 'custom:email_linkedin' in dict_token ? dict_token['custom:email_linkedin'] : 'NaN',
        //             "role": 'custom:role' in dict_token ? dict_token['custom:role'] : 'user',
        //             "lastWithdrawRun": 'custom:lastWithdrawRun' in dict_token ? dict_token['custom:lastWithdrawRun'] : '1549580400',
        //             "haveAccount": 'custom:haveAccount' in dict_token ? (dict_token['custom:haveAccount'] === 'true') : false,
        //             "isBlocked": 'custom:isBlocked' in dict_token ? (dict_token['custom:isBlocked'] === 'true') : true,
        //             "referrer": 'custom:referrer' in dict_token ? dict_token['custom:referrer'] : 'YSY',
        //             "emailInstagram": 'custom:email_instagram' in dict_token ? dict_token['custom:email_instagram'].split(',') : [],
        //             "haveAccountInstagram": 'custom:haveAccountInstagram' in dict_token ? (dict_token['custom:haveAccountInstagram'] === 'true') : false,
        //         };
        //         console.log(payload);
        //         this.$store.commit('auth_success', payload);
        //         if (dict_token['cognito:username'] === 'branchofapp') {
        //             this.$router.push({name: 'adminysy'})
        //             return
        //         }
        //         if (dict_token['custom:isBlocked'] === 'true') {
        //             this.$router.push({name: 'Profile'})
        //         } else {
        //             this.$router.push({name: 'Dashboard'})
        //         }
        //     }
        // },
        created() {
            window.location = "https://upgrademe.auth.eu-west-1.amazoncognito.com/login?response_type=code&client_id=" + this.API_KEY_CLIENT_VUE + "&redirect_uri=" + this.CALLBACK_UI_COGNITO + "/authentication"
        }

    };
</script>
<style></style>
